var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconManagerallocate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18.232,
    viewBox: "0 0 19 18.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_managerallocate",
    d: "M8.433,12.448a4.784,4.784,0,1,1,4.784,4.784A4.789,4.789,0,0,1,8.433,12.448Zm3.143-2.136,2.136,2.136-2.136,2.136L12.6,15.6l3.156-3.156L12.6,9.292ZM0,12.448A5.231,5.231,0,0,1,8.512,8.373,6.2,6.2,0,0,0,6.99,12.448ZM2.345,2.887A2.887,2.887,0,1,1,5.232,5.773,2.887,2.887,0,0,1,2.345,2.887Z",
    transform: "translate(0.5 0.5)",
    fill: "#0045d9",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagerallocate);
export default __webpack_public_path__ + "static/media/icon_managerallocate.5fc0b4f3d439bf83692da3d3030def33.svg";
export { ForwardRef as ReactComponent };